import {
  ReasonForEncounterDto,
  ReasonForEncounterSearchRequest,
  UpsertReasonForEncounterDto
} from 'ts-types/api.types';
import { CancelTokenSource } from 'axios';
import axios from './http';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/reasons-for-encounter`;

export const getAllReasonsForEncounter = (source: CancelTokenSource): Promise<Array<ReasonForEncounterDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchReasonForEncounter = (reasonsForEncounterSearchRequest: Partial<ReasonForEncounterSearchRequest>,
                                          source: CancelTokenSource): Promise<Array<ReasonForEncounterDto>> => {
  return axios
      .post(`${apiUri}/search`,reasonsForEncounterSearchRequest,{cancelToken: source.token})
      .then(response => response.data)
};

export const findReasonForEncounterById = (id: number, source: CancelTokenSource): Promise<UpsertReasonForEncounterDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addReasonForEncounter = (upsertReasonForEncounterDto: Partial<UpsertReasonForEncounterDto>,
                                      source: CancelTokenSource): Promise<ReasonForEncounterDto> => {
  return axios
      .post(apiUri, upsertReasonForEncounterDto, {cancelToken: source.token})
      .then(response => response.data)
};

export const editReasonForEncounter = (id: number, upsertReasonForEncounterDto: Partial<UpsertReasonForEncounterDto>,
                                       source: CancelTokenSource): Promise<ReasonForEncounterDto> => {
  return axios
      .put(`${apiUri}/${id}`,upsertReasonForEncounterDto, {cancelToken: source.token})
      .then(response => response.data)
};

export  const deleteReasonForEncounter = (id: number, source: CancelTokenSource): Promise<ReasonForEncounterDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
